export default __webpack_public_path__ + "static/media/fb-icon.56e4b94f.svg";